<mat-drawer-container class="container" hasBackdrop>
  <mat-drawer #drawer class="sidenav" mode="over">
    <app-sidenav-content></app-sidenav-content>
  </mat-drawer>
  <app-header-toolbar *ngIf="loginService.logeado" [local]="pickupService.usuario.nombre_local"
                      [usuario]="pickupService.usuario.nombre_usuario"></app-header-toolbar>
  <div (click)="detenerSonido()" class="content">
    <div *ngIf="showingPopup" class="popup">
      <div class="icon">
        <mat-icon>notification_important</mat-icon>
      </div>
      <div class="text">{{ popupText }}</div>
      <div class="action">
        <button (click)="closePopup()" color="primary" mat-raised-button>Aceptar</button>
      </div>
    </div>
    <router-outlet></router-outlet>
  </div>

  <div class="version">
    <p style="text-align: left; color:gray">
      Version {{ appVersion }}
    </p>
  </div>
</mat-drawer-container>
